angular.module('leanlaw').filter("yesno", ['$filter', function ($filter) {
  return function (bool, undefinedIsFalse) {
    if (bool === false || !bool && undefinedIsFalse) return "No";
    if (bool) return "Yes";
    return "";
  };
}]);